import initVueApp from "@/core.js";
const component = require(`./../views/Help.vue`).default;
initVueApp(component);
